import AcademyProgramVariantWidget from "../../AcademyProgramVariantWidget";

export default function AcademyVariantAttachedView() {
  return <AcademyProgramVariantWidget />;
}
